/**
 * Emarsys Standard JS-Library, used via Google Tag Manager
 */
var _ems_url = document.location;
var _ems_tracking_image = (_ems_url.protocol == "https:" ? "https:" : "http:") + "//www.emarsys.net/upages/ti.php";
var _ems_hash = _ems_url.hash.substring(1);
var _ems_session_timeout = 600;
var _ems_campaign_timeout = 30 * 24 * 3600;
var _ems_domain = document.domain;
var _ems_never = "Tue, 31 Dec 2030 23:59:59 GMT";
var _ems_tracking_param = "emst";
var _ems_customer = "";
var _ems_visitor = "";
var _ems_session = "";
var _ems_campaign = "";
var _ems_debug = 0;

function ems_Debug() {
    var a = "_ems_url: " + escape(_ems_url) + "\n_ems_tracking_image: " + escape(_ems_tracking_image) + "\n_ems_hash: " + escape(_ems_hash) + "\n_ems_session_timeout: " + escape(_ems_session_timeout) + "\n_ems_campaign_timeout: " + escape(_ems_campaign_timeout) + "\n_ems_domain: " + escape(_ems_domain) + "\n_ems_never: " + escape(_ems_never) + "\n_ems_tracking_param: " + escape(_ems_tracking_param) + "\n_ems_customer: " + escape(_ems_customer) + "\n_ems_visitor: " + escape(_ems_visitor) + "\n_ems_session: " + escape(_ems_session) + "\n_ems_campaign: " + escape(_ems_campaign) + "\n";
    alert(a)
}

function emsSetEnv(a) {
    _ems_tracking_image = (_ems_url.protocol == "https:" ? "https:" : "http:") + "//" + a + ".emarsys.net/upages/ti.php"
}

function emsTracking(c, b) {
    if (c) {
        _ems_customer = c
    }
    if (b) {
        _ems_domain = b
    }
    if (_ems_url.protocol == "file:") {
        return
    }
    var a = new Date();
    domain_hash = DJBHash(_ems_domain.substring(0, 4) == "www." ? _ems_domain.substring(4, _ems_domain.length) : _ems_domain);
    _ems_session = _ems_getCookie("_ems_session=" + domain_hash + ".");
    if (_ems_session == "") {
        if (_ems_debug) {
            alert("creating new session cookie")
        }
        _ems_session = Math.round(Math.random() * 1073741824);
        var e = new Date(a.getTime() + (_ems_session_timeout * 1000));
        document.cookie = "_ems_session=" + domain_hash + "." + _ems_session + ";path=/;domain=." + _ems_domain + ";expires=" + e.toGMTString() + ";"
    }
    _ems_visitor = _ems_getCookie("_ems_visitor=" + domain_hash + ".");
    if (_ems_visitor == "") {
        if (_ems_debug) {
            alert("creating new visitor cookie")
        }
        _ems_visitor = _ems_session;
        document.cookie = "_ems_visitor=" + domain_hash + "." + _ems_visitor + ";path=/;domain=." + _ems_domain + ";"
    }
    _ems_campaign = _ems_getParam(document.location.search, _ems_tracking_param);
    if (_ems_campaign == "") {
        _ems_campaign = _ems_getCookie("_ems_campaign=" + domain_hash + ".")
    } else {
        if (_ems_debug) {
            alert("creating new campaign cookie")
        }
        var e = new Date(a.getTime() + (_ems_campaign_timeout * 1000));
        document.cookie = "_ems_campaign=" + domain_hash + "." + _ems_campaign + ";path=/;domain=." + _ems_domain + ";expires=" + e.toGMTString() + ";"
    }
}

function _ems_Tick() {
    var a = "ems_customer=" + _ems_escape(_ems_customer) + "&ems_visitor=" + _ems_escape(_ems_visitor) + "&ems_session=" + _ems_escape(_ems_session) + "&ems_campaign=" + _ems_escape(_ems_campaign) + "&ems_page=" + _ems_escape(document.location.pathname + _ems_StripParam(document.location.search, _ems_tracking_param));
    var b = new Image();
    b.src = _ems_tracking_image + "?" + a
}

function _ems_StripParam(a, b) {
    if (a.indexOf(b + "=") > 0) {
        value = _ems_getParam(a, b);
        a = a.substr(0, a.indexOf(b)) + a.substr(a.indexOf(b) + b.length + value.length + 2, a.length);
        if (a.substr(a.length - 1, 1) == "&") {
            a = a.substr(0, a.length - 1)
        }
    }
    return (a == "?" ? "" : a)
}

function emsSubmitOrder() {
    if (_ems_customer == "" || _ems_campaign == "") {
        return
    }
    ems_items = document.getElementsByName("ems_items[]");
    var p = "ems_customer=" + _ems_escape(_ems_customer) + "&ems_session=" + _ems_escape(_ems_session) + "&ems_visitor=" + _ems_escape(_ems_visitor) + "&ems_campaign=" + _ems_escape(_ems_campaign) + "&ems_action=purchase";
    order_fields = new Array("order", "total", "tax", "shipping", "city", "country");
    for (var i = 0; i < order_fields.length; i++) {
        if (eval("document.emsform." + order_fields[i])) {
            p += "&" + order_fields[i] + "=" + eval("document.emsform." + order_fields[i] + ".value")
        }
    }
    item_fields = new Array("code", "category", "productname", "price", "quantity");
    for (var j = 0; j < ems_items.length; j++) {
        var item_values = ems_items[j].value.split(";");
        for (var i = 0; i < item_fields.length; i++) {
            p += "&" + item_fields[i] + "[]=" + (item_values.length > i ? item_values[i] : "")
        }
    }
    var image = new Image();
    image.src = _ems_tracking_image + "?" + p;
    if (_ems_debug) {
        alert("image.src=" + image.src)
    }
}

function _ems_getParam(c, a) {
    if (c.charAt(0) == "?") {
        c = c.substring(1, c.length)
    }
    params = c.split("&");
    for (var b = 0; b < params.length; b++) {
        param = params[b].split("=");
        if (param[0] == a) {
            return param[1]
        }
    }
    return ""
}

function _ems_getCookie(c) {
    var b = document.cookie.indexOf(c);
    if (b >= 0) {
        var d = b + c.length;
        var a = document.cookie.indexOf(";", d);
        if (a == -1) {
            a = document.cookie.length
        }
        return document.cookie.substring(d, a)
    }
    return ""
}

function DJBHash(e) {
    var b = 5381;
    for (var a = 0; a < e.length; a++) {
        var f = parseInt(e.charCodeAt(a));
        b = ((b << 5) + b) + f
    }
    return (b & 2147483647)
}

function _ems_escape(a) {
    return typeof(encodeURIComponent) == "function" ? encodeURIComponent(a) : escape(a)
};